<template>
    <form @submit.prevent="submitOutOfMarketLeadspediaForm()">
        <div class="ls-out-of-market-leadspedia-form__container grid">
            <div class="grid__col-12 ls-out-of-market-leadspedia-form__top-text">
                <h3>Get Free Quotes From Up to 4 Trusted Professionals</h3>
                <span
                    >Fill in the below details to get free estimates from the best local
                    professionals near you.</span
                >
            </div>
            <div class="ls-out-of-market-leadspedia-form--divider"></div>

            <div class="grid__col-12">
                <slot></slot>
            </div>
            <div class="grid">
                <div class="grid__col-12">
                    <h2
                        class="ls-condensed"
                        :class="{
                            'ls-out-of-market-leadspedia-form--invalid': validation.servicesInvalid,
                        }"
                    >
                        What services are you interested in?
                    </h2>
                </div>
                <div class="grid__col-xs-12 grid__col-sm-10">
                    <div class="ls-out-of-market-leadspedia-form__outer-container">
                        <div
                            v-for="(service, idx) in services"
                            :key="`${idx} - ${service.id}`"
                            class="ls-out-of-market-leadspedia-form__inner-container ls-margin--top"
                        >
                            <label
                                class="ls-button ls-button--block ls-button--checkbox"
                                :class="{
                                    'ls-button--green ls-button--faded': service.selected,
                                }"
                            >
                                <input type="checkbox" @change="updateServices({ idx })" />
                                <span class="ls-button-toggle-icon">
                                    <i
                                        class="fa"
                                        :class="{
                                            'fa-check-square ls-color--green--color-dodge':
                                                service.selected,
                                            'fa-square-o ls-color--gray--light': !service.selected,
                                        }"
                                    ></i>
                                </span>
                                <span>{{ service.name }}</span>
                            </label>
                        </div>

                        <div
                            v-if="services[withChildrenIdx].selected"
                            class="ls-out-of-market-leadspedia-form--child-services-wrapper"
                        >
                            <span
                                class="ls-bold ls-uppercase ls-color--green--color-dodge"
                                :class="{
                                    'ls-out-of-market-leadspedia-form--invalid':
                                        validation.withChildrenInvalid,
                                }"
                                data-font-size="0"
                                >CHOOSE {{ services[withChildrenIdx].name }} TYPE</span
                            >
                            <div
                                v-for="(childService, childIdx) in services[withChildrenIdx]
                                    .child_services"
                                :key="childService.str_id"
                                class="ls-margin--top"
                            >
                                <label class="ls-checkbox">
                                    <input
                                        type="checkbox"
                                        @change="updateServices({ idx: withChildrenIdx, childIdx })"
                                    />
                                    <i
                                        class="fa fa-lg fa-fw"
                                        :class="{
                                            'fa-check-square ls-color--green--color-dodge':
                                                childService.selected,
                                            'fa-plus-square ls-color--gray--light': !childService.selected,
                                        }"
                                    ></i>
                                    <span data-font-size="-1">{{ childService.name }}</span>
                                </label>
                                <div
                                    v-if="childService.selected && childService.notes_required"
                                    class="ls-input__wrapper"
                                    :class="{ 'ls-padding--right': !screenSize.xs }"
                                >
                                    <textarea
                                        id="child-notes"
                                        v-model="childService.notes"
                                        v-ls-track.change="{
                                            target: `out-of-market-leadspedia-form--${childService.str_id}-notes`,
                                            attachValue: true,
                                        }"
                                        class="ls-input"
                                        type="textbox"
                                        rows="2"
                                        :class="{
                                            'ls-invalid': validation.childNotesInvalid,
                                        }"
                                        @change="updateChildNotesValidation"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ls-out-of-market-leadspedia-form--divider"></div>

            <div class="grid">
                <div class="grid__col-12">
                    <h2
                        class="ls-condensed"
                        :class="{
                            'ls-out-of-market-leadspedia-form--invalid': validation.budgetInvalid,
                        }"
                    >
                        Additional Details
                    </h2>
                </div>

                <div class="grid__col-sm-10">
                    <label class="ls-label ls-margin--top" for="notes"
                        >Other details about what you need</label
                    >
                    <div class="ls-input__wrapper" :class="{ 'ls-padding--right': !screenSize.xs }">
                        <textarea
                            id="notes"
                            v-model="notes"
                            v-ls-track.change="{
                                target: 'out-of-market-leadspedia-form--notes',
                                attachValue: true,
                            }"
                            class="ls-input"
                            type="textbox"
                            rows="3"
                            testID="notes"
                        ></textarea>
                    </div>

                    <label class="ls-label ls-margin--top" for="budget">Budget</label>
                    <div
                        class="ls-input__wrapper for-select"
                        :class="{ 'ls-margin--right': !screenSize.xs }"
                    >
                        <select
                            id="budget"
                            v-model="budget"
                            v-ls-track.change="{
                                target: 'out-of-market-leadspedia-form--budget',
                                attachValue: true,
                            }"
                            class="ls-input"
                            testID="budget"
                            :class="{ 'ls-invalid': validation.budgetInvalid }"
                            @change="updateBudgetValidation"
                        >
                            <option :value="{}" selected disabled>- Select -</option>
                            <option
                                v-for="budget in budgetOptions"
                                :key="budget.label"
                                :value="budget.value"
                            >
                                {{ budget.label }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="ls-out-of-market-leadspedia-form--divider"></div>
        </div>

        <ls-panel class="ls-border-all ls-border-top-none">
            <ls-contact-info :title="'How can we get in touch with you?'"></ls-contact-info>
            <ls-error></ls-error>

            <div slot="button" class="grid">
                <div class="grid__col-12 ls-margin--top">
                    <button
                        v-ls-track.click="{
                            target: 'out-of-market-leadspedia-form--submit',
                        }"
                        class="ls-button ls-button--block ls-button--lg ls-button--yellow ls-margin--top"
                        type="submit"
                        :disabled="orderServiceLead.loadingStatus.isUpdating"
                    >
                        <span v-if="orderServiceLead.loadingStatus.isUpdating"
                            ><i class="fa fa-pulse fa-spinner"></i>&nbsp;Submitting</span
                        >
                        <span v-else>GET FREE QUOTES</span>
                    </button>
                </div>
            </div>
            <div class="ls-out-of-market-leadspedia-form__disclosure grid__col-12">
                <span>
                    By clicking GET FREE QUOTES, I agree to LawnStarter's
                    <span
                        v-ls-track.click="{
                            target: 'out-of-market-leadspedia-form--open-tos-modal',
                        }"
                        class="ls-out-of-market-leadspedia-form__tos"
                        test-id="tos"
                        @click.prevent.stop="openModal('termsOfService')"
                        >terms of service</span
                    >
                    and I agree that LawnStarter or one of its partners (including HomeAdvisor) may
                    contact me by phone, SMS, or email, including for marketing purposes and through
                    automated phone technology. LawnStarter may earn either a commission or a flat
                    amount from its partners for giving professionals the opportunity to bid on your
                    project.
                </span>
            </div>
        </ls-panel>
    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import VueScrollTo from 'vue-scrollto';
import {
    ORDER_SERVICE_LEAD__SUBMIT_LEADSPEDIA,
    ORDER_SERVICE_LEAD__UPDATE_OUT_OF_MARKET,
    MODAL__OPEN_MODAL,
} from '@/store/types';
import eventBusService from '@/services/event-bus.service';
import lsPanel from '@/components/original-mydot/panel/Panel.vue';
import lsContactInfo from '@/components/original-mydot/contact-info/ContactInfo.vue';
import lsError from '@/components/original-mydot/error/Error.vue';

import lsTrackService from '@/services/ls-track/ls-track.service';

export default {
    name: 'LsOutOfMarketLeadspediaForm',
    components: {
        lsPanel,
        lsContactInfo,
        lsError,
    },
    data() {
        return {
            // form
            services: [],
            notes: '',
            budget: {},
            budgetOptions: [],
            validation: {
                servicesInvalid: undefined,
                withChildrenInvalid: undefined,
                childNotesInvalid: undefined,
                budgetInvalid: undefined,
            },
            withChildrenIdx: null,
            childNotesIdx: null,
        };
    },
    computed: {
        ...mapState(['orderServiceLead', 'screenSize', 'contactInfo']),
    },
    methods: {
        ...mapActions({
            updateOutOfMarket: ORDER_SERVICE_LEAD__UPDATE_OUT_OF_MARKET,
            submitForm: ORDER_SERVICE_LEAD__SUBMIT_LEADSPEDIA,
            openModal: MODAL__OPEN_MODAL,
        }),
        updateServicesValidaton() {
            this.validation.servicesInvalid = !_.some(this.services, {
                selected: true,
            });
        },
        updateBudgetValidation() {
            this.validation.budgetInvalid = _.isEmpty(this.budget);
        },
        updateWithChildrenValidation({ skipDirtyCheck } = {}) {
            if (!skipDirtyCheck && _.isUndefined(this.validation.withChildrenInvalid)) {
                this.validation.withChildrenInvalid = null;
                return;
            }

            const serviceWithChildren = this.services[this.withChildrenIdx];

            this.validation.withChildrenInvalid =
                Boolean(serviceWithChildren.selected) &&
                !_.some(serviceWithChildren.child_services, {
                    selected: true,
                });
        },
        updateChildNotesValidation({ skipDirtyCheck } = {}) {
            if (!skipDirtyCheck && _.isUndefined(this.validation.childNotesInvalid)) {
                this.validation.childNotesInvalid = null;
                return;
            }
            const serviceWithChildren = this.services[this.withChildrenIdx];
            const childServiceWithNotes = serviceWithChildren.child_services[this.childNotesIdx];

            this.validation.childNotesInvalid =
                Boolean(serviceWithChildren.selected) &&
                Boolean(childServiceWithNotes.selected) &&
                childServiceWithNotes.notes === '';
        },
        checkFormValidation() {
            this.updateServicesValidaton();
            this.updateBudgetValidation();
            this.updateWithChildrenValidation({ skipDirtyCheck: true });
            this.updateChildNotesValidation({ skipDirtyCheck: true });

            return (
                !this.validation.servicesInvalid &&
                !this.validation.budgetInvalid &&
                !this.validation.withChildrenInvalid &&
                !this.validation.childNotesInvalid &&
                this.contactInfo.valid
            );
        },
        updateServices({ idx, childIdx }) {
            const selectedService = _.isNil(childIdx)
                ? this.services[idx]
                : this.services[this.withChildrenIdx].child_services[childIdx];

            if (!_.isNil(idx) && _.isNil(childIdx)) {
                lsTrackService.track({
                    type: 'change',
                    target: 'out-of-market-leadspedia-form--parent-service',
                    data: {
                        str_id: selectedService.str_id,
                    },
                });

                selectedService.selected = !selectedService.selected;

                _.forEach(this.services, (service) => {
                    if (service.name !== selectedService.name) {
                        // eslint-disable-next-line no-param-reassign
                        service.selected = false;
                    }
                });

                // always clear child services prior to potentially setting it below
                _.forEach(this.services[this.withChildrenIdx].child_services, (service) => {
                    // eslint-disable-next-line no-param-reassign
                    service.selected = false;
                });
            }

            if (!_.isNil(childIdx)) {
                lsTrackService.track({
                    type: 'change',
                    target: 'out-of-market-leadspedia-form--child-service',
                    data: {
                        str_id: selectedService.str_id,
                    },
                });

                selectedService.selected = !selectedService.selected;

                _.forEach(this.services[this.withChildrenIdx].child_services, (service) => {
                    if (service.id !== selectedService.id) {
                        // eslint-disable-next-line no-param-reassign
                        service.selected = false;
                    }
                });
            }

            this.updateServicesValidaton();

            if (idx === this.withChildrenIdx) {
                this.updateWithChildrenValidation();
                if (childIdx === this.childNotesIdx) {
                    this.updateChildNotesValidation();
                }
            }
        },
        enabledTrustedForm() {
            const field = 'xxTrustedFormCertUrl';
            const provideReferrer = false;
            const invertFieldSensitivity = false;
            const tf = document.createElement('script');
            tf.type = 'text/javascript';
            tf.async = true;
            tf.src = _.concat(
                'https://api.trustedform.com/trustedform.js?provide_referrer=',
                escape(provideReferrer),
                '&field=',
                escape(field),
                '&l=',
                new Date().getTime(),
                Math.random(),
                '&invert_field_sensitivity=',
                invertFieldSensitivity
            );
            const s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(tf, s);
        },
        submitOutOfMarketLeadspediaForm() {
            if (!this.checkFormValidation()) {
                eventBusService.eventBus.$emit('submitButtonClick');

                const invalidFields = _.pickBy(this.validation, (value) => value === true);

                lsTrackService.track({
                    type: 'submitLeadspediaFormInvalid',
                    data: {
                        invalidFields,
                    },
                });

                setTimeout(() => {
                    let firstInvalidInput = null;
                    const outOfMarketLeadspediaFirstElement = document.getElementsByClassName(
                        'ls-out-of-market-leadspedia-form--invalid'
                    )[0];
                    const lsInvalidFirstElement = document.getElementsByClassName('ls-invalid')[0];

                    // because we have a mix of both classes on the LsOutOfMarketLeadspediaForm component, we'll need to detect which is higher on the page if both have an invalid item
                    if (outOfMarketLeadspediaFirstElement) {
                        if (lsInvalidFirstElement) {
                            firstInvalidInput =
                                outOfMarketLeadspediaFirstElement.getBoundingClientRect().top <
                                lsInvalidFirstElement.getBoundingClientRect().top
                                    ? outOfMarketLeadspediaFirstElement
                                    : lsInvalidFirstElement;
                        } else {
                            firstInvalidInput = outOfMarketLeadspediaFirstElement;
                        }
                    } else {
                        firstInvalidInput = lsInvalidFirstElement;
                    }

                    if (firstInvalidInput) {
                        const offset = this.screenSize.xs || this.screenSize.sm ? -150 : -105; // offset to account for the sticky header + the input label
                        VueScrollTo.scrollTo(firstInvalidInput, 500, { offset });
                    }
                });
                return;
            }
            const trustedFormId = _.get(window, 'trustedForm.id');
            const payload = {
                notes: this.notes,
                budget: this.budget,
                services: this.services,
                trusted_form_id: trustedFormId,
            };

            this.submitForm({ payload });
        },
    },
    destroyed() {
        this.updateOutOfMarket({
            services: this.services,
            additionalDetails: {
                budget: this.budget,
                notes: this.notes,
            },
        });
    },
    created() {
        const { orderServiceLead } = this;

        this.services = _.map(orderServiceLead.outOfMarket.services, (service, idx) => {
            if (_.size(service.child_services)) {
                this.withChildrenIdx = idx;
            }

            const child_services = _.map(service.child_services, (childService, childIdx) => {
                if (childService.notes_required) {
                    this.childNotesIdx = childIdx;
                }
                return {
                    ...childService,
                    selected: Boolean(childService.selected),
                    notes: childService.notes_required ? childService.notes || '' : null,
                    notes_required: childService.notes_required,
                };
            });

            return {
                ...service,
                selected: Boolean(service.selected),
                child_services,
            };
        });

        this.notes = orderServiceLead.additionalDetails.notes;

        this.budgetOptions = _.map(orderServiceLead.outOfMarket.budgets, (budget, idx) => {
            const low = _.replace(budget.low, /\B(?=(\d{3})+(?!\d))/g, ',');
            const high = _.replace(budget.high, /\B(?=(\d{3})+(?!\d))/g, ',');
            let label = `$${low} – $${high}`;

            if (idx === 0) {
                label = `Up to $${high}`;
            } else if (idx === _.size(orderServiceLead.budgets) - 1) {
                label = `$${low}+`;
            }

            return {
                label,
                value: budget,
            };
        });

        this.budget = orderServiceLead.additionalDetails.budget;
        this.enabledTrustedForm();
    },
};
</script>

<style lang="scss">
.ls-out-of-market-leadspedia-form__container {
    background-color: palette(white);
    border: 1px solid #d5dbd9;
    border-bottom: none;
    // align with ls-panel
    padding: 0 11px;

    h3 {
        padding-top: 20px;
    }

    span {
        font-size: 14px;
    }
}

.ls-out-of-market-leadspedia-form__top-text {
    display: flex;
    justify-content: center;
    align-items: center;
}

.ls-input {
    resize: none;
}

.ls-out-of-market-leadspedia-form__outer-container {
    display: flex;
    flex-wrap: wrap;
}

.ls-out-of-market-leadspedia-form__inner-container {
    flex: 0 0 auto;
    padding-right: rem(0);
    width: 50%;

    @include max-screen(breakpoint(xs, max)) {
        padding-right: 0;
        width: 100%;
    }
}

.ls-out-of-market-leadspedia-form--invalid {
    color: palette(red) !important;
}

.ls-out-of-market-leadspedia-form--divider {
    background-color: #d5dbd9;
    height: 1px;
    margin: 24px 16px 16px 16px;
    width: 100%;

    &:last-of-type {
        margin-bottom: 0;
    }
}

.ls-checkbox {
    display: flex;
    margin-left: 0;
    margin-bottom: rem(-3);
    padding-right: rem(-3);
    user-select: none;

    i {
        padding-right: rem(0);
        margin-top: 3px;
        font-size: rem(0);
    }

    span:before {
        // override spacing used elsewhere since we're using fa checkboxes
        content: '';
    }

    input {
        display: none;
    }
}

.ls-out-of-market-leadspedia-form--child-services-wrapper {
    border: 1px solid #abb8b2;
    padding: 15px;
    margin-top: 15px;
    width: 100%;
}

.ls-out-of-market-leadspedia-form__disclosure {
    font-size: 12px;
    padding-top: 24px;
}

.ls-out-of-market-leadspedia-form__tos {
    color: palette(blue);
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
}
</style>
